var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21653",
    "data-name": "Rectangle 21653",
    width: 16,
    height: 16,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37607",
    "data-name": "Group 37607",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80518",
    "data-name": "Path 80518",
    d: "M8,.73A7.267,7.267,0,1,1,.729,8,7.274,7.274,0,0,1,8,.73",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#5a5695",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80519",
    "data-name": "Path 80519",
    d: "M9.732,11.156c-.038.149-.069.283-.11.415-.008.026-.05.05-.081.06a9.162,9.162,0,0,1-1.066.34,1.652,1.652,0,0,1-1.292-.2.98.98,0,0,1-.452-.946,8.3,8.3,0,0,1,.379-1.6c.1-.371.207-.741.278-1.118.1-.514-.108-.725-.631-.676-.187.018-.371.073-.57.113.034-.137.064-.272.1-.4a.129.129,0,0,1,.069-.074,4.147,4.147,0,0,1,1.7-.384,1.121,1.121,0,0,1,1.053.8,2.2,2.2,0,0,1-.073,1c-.171.631-.352,1.258-.52,1.89a1.9,1.9,0,0,0-.052.432.391.391,0,0,0,.368.441,1.522,1.522,0,0,0,.812-.082.535.535,0,0,1,.082-.013",
    transform: "translate(0 -0.003)",
    fill: "#5a5695"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80520",
    "data-name": "Path 80520",
    d: "M8.8,4A.956.956,0,0,1,9.811,5.064a1,1,0,0,1-.946.8,1.023,1.023,0,0,1-1.085-.8A.96.96,0,0,1,8.8,4",
    transform: "translate(0 -0.002)",
    fill: "#5a5695"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToooltip);
export default __webpack_public_path__ + "static/media/toooltip.4f0f707567729841e9f2de5d1a71425b.svg";
export { ForwardRef as ReactComponent };